@import (reference) '../../../../../constants/spacing.module.less';

.section-title {
  margin-bottom: @space-16;
}

.details-grid {
  display: flex;
  flex-wrap: wrap;
}

.details-column {
  flex: 1;
  min-width: 200px;
  margin-right: @space-32;

  &:last-child {
    margin-right: 0;
  }
}

.full-width-column {
  flex: 1 1 100%;
  margin-bottom: @space-16;
}

.label {
  display: block;
  margin-bottom: @space-4;
}

.value {
  display: block;
  margin-bottom: @space-8;
}

.expandable-header-container {
  padding: @space-8 @space-0 !important;
  color: var(--grey-900);
}

.expandable-content-container {
  padding: 0 0 @space-16 !important;
}

.shipping-details-wrapper {
  margin: @space-0 @space-16;
  border-color: var(--grey-300);
}
